import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_skip_empty_ancillary_page",
  stages: {
    decide_steps: 1,
    decide_steps_no_ancillary: 2,
    decide_steps_no_ancillary_ddot: 3,
    decide_steps_no_ancillary_mdot: 4,
    next_to_ancillary: 5, // main
    next_to_ancillary_ddot: 6,
    next_to_ancillary_mdot: 7
  },
  goals: {
    meal_offered: 1,
    empty_extras_page: 2
  },
  defaultStage: 1
});

export default { ...utils };
